import { meta, shopify, starbucks, tesla } from "../assets/images";
import {
    contact,
    css,
    git,
    github,
    html,
    javascript,
    linkedin,
    mongodb,
    mui,
    nextjs,
    nodejs,
    react,
    redux,
    tailwindcss,
    typescript
} from "../assets/icons";

import postgres from '../assets/icons/postgres.svg';
import solidity from '../assets/icons/solidity.svg';
import laravel from '../assets/icons/laravel.svg';
import blockchain from '../assets/icons/blockchain.svg';
import python from '../assets/icons/python.svg';
import googleCloud from '../assets/icons/googleCloud.svg';
import pf from '../assets/icons/pf.svg';
import nexus from '../assets/icons/nexus.svg';
import rti from '../assets/icons/rti.svg';
import algo  from "../assets/icons/algo.svg";
import nn  from "../assets/icons/nn.svg";
import amazon  from "../assets/icons/amazon.svg";
import foundryBanner  from "../assets/icons/foundryBanner.svg";
import stablecoin  from "../assets/icons/stablecoin.svg";

export const skills = [
    {
        imageUrl: css,
        name: "CSS",
        type: "Frontend",
    },

    {
        imageUrl: html,
        name: "HTML",
        type: "Frontend",
    },
    {
        imageUrl: javascript,
        name: "JavaScript",
        type: "Frontend",
    },
    {
        imageUrl: react,
        name: "React",
        type: "Frontend",
    },
    {
        imageUrl: git,
        name: "Git",
        type: "Version Control",
    },
    {
        imageUrl: github,
        name: "GitHub",
        type: "Version Control",
    },
    {
        imageUrl: mongodb,
        name: "MongoDB",
        type: "Database",
    },

    {
        imageUrl: mui,
        name: "Material-UI",
        type: "Frontend",
    },
    {
        imageUrl: nextjs,
        name: "Next.js",
        type: "Frontend",
    },
    {
        imageUrl: nodejs,
        name: "Node.js",
        type: "Backend",
    },

    {
        imageUrl: tailwindcss,
        name: "Tailwind CSS",
        type: "Frontend",
    },
    {
        imageUrl: typescript,
        name: "TypeScript",
        type: "Frontend",
    },
    {
        imageUrl: postgres,
        name: "Postgres",
        type: "Backend",
    },
    {
        imageUrl: solidity,
        name: "Solidity",
        type: "Backend",
    },
    {
        imageUrl: foundryBanner,
        name: "Foundry",
        type: "Backend",
    },
    {
        imageUrl: laravel,
        name: "Laravel",
        type: "Backend",
    },
    {
        imageUrl: blockchain,
        name: "Blockchain",
        type: "Backend",
    },
    {
        imageUrl: python,
        name: "Python",
        type: "Backend",
    },
    {
        imageUrl: googleCloud,
        name: "GCP",
        type: "DevOps",
    },

];

export const experiences = [
    {
        title: "Full-stack Developer (Remote)",
        company_name: "Nexus Generator",
        icon: nexus,
        iconBg: "#accbe1",
        date: "Oct 2022 - Aug 2023",
        points: [
            "Developed the AI generative engine interface given the wireframes. ",
            "Served as the AI API developer responsible for integrating open-source AI models (Stable Diffusion, Riffusion, Sadtalker) with the front-end through RESTful APIs.",
        ],
    },
    {
        title: "Trainee Backend Engineer",
        company_name: "ProgrammersForce",
        icon: pf,
        iconBg: "#b7e4c7",
        date: "May 2023 - Aug 2023",
        points: [
            "Developing an Access Control System (ACL) utilizing Laravel's spatie package",
            "Contributed to developing a Customer Relationship Management software (CRM), leveraging Google APIs.",
            "Implementing responsive design and ensuring cross-browser compatibility.",
            "Participating in code reviews and providing constructive feedback to other developers.",
        ],
    },
    {
        title: "Web Developer",
        company_name: "Raa Trade International",
        icon: rti,
        iconBg: "#fed7aa",
        // iconBg: "#fca5a5",
        date: "Sept 2021 - Jan 2022",
        points: [
            "Coded React-Electron Native Desktop Application for managing inventory.",
            "Skills: Electron.js, React.js, TailwindCSS",
        ],
    },

];

export const socialLinks = [
    {
        name: 'Contact',
        iconUrl: contact,
        link: '/contact',
    },
    {
        name: 'GitHub',
        iconUrl: github,
        link: 'https://github.com/YourGitHubUsername',
    },
    {
        name: 'LinkedIn',
        iconUrl: linkedin,
        link: 'https://www.linkedin.com/in/YourLinkedInUsername',
    }
];

export const projects = [
    {
        iconUrl: stablecoin,
        theme: 'btn-back-blue',
        name: 'Decentralized Stablecoin Protocol',
        description: "A Stablecoin protocol; dollar-pegged, no fees and only backed by WETH and WBTC.",
        link: "https://github.com/FalseGenius/foundry-security-defi",
        liveLink:null
    },
    {
        iconUrl: nn,
        theme: 'btn-back-red',
        name: 'Real-time-Face-Recognition',
        description: 'Built a demo face recognition system using Siamese Network with TensorFlow.',
        link: 'https://github.com/FalseGenius/Real-time-Face-Recognition',
        liveLink:null
    },
    {
        iconUrl: algo,
        theme: 'btn-back-green',
        name: 'Path Finding Visualizer',
        description: "Built ReactJS application for visualizing, and pathfinding using Dijkstra’s algorithm.",
        link: 'https://github.com/FalseGenius/PathFindingVisualizer',
        liveLink:'https://falsegenius.github.io/PathFindingVisualizer/'
    
    },
    {
        iconUrl: blockchain,
        theme: 'btn-back-pink',
        name: 'Next.js/Solidity Dapp',
        description: 'A Decentralized Chat App, powered by Web3, leveraging Next.js and Smart Contracts.',
        link: 'https://github.com/FalseGenius/dApp-chat-app',
        liveLink:'https://d-app-chat-app.vercel.app/'
    },

];